export const formations = [
  {
    icon: "🎓",
    title: "2016 - 2019",
    subtitle: "Baccalauréat Technologique",
    description: "Sciences et Technologies de l’agronomie et du vivant",
    link: "bac_technologique.jpg",
  },
  {
    icon: "🏆",
    title: "2022",
    subtitle: "Baccalauréat Professionnel",
    description:
      "Conduite et gestion d’une entreprise dans le secteur canin et félin (Meilleure Apprentie de France 2022)",
    link: "bac_professionnel.jpg",
  },
  {
    icon: "🐾",
    title: "2022",
    subtitle: "Transports d’animaux Vivants (TAV)",
    description:
      "Certification attestant des compétences nécessaires pour assurer le transport des animaux dans le respect du bien-être animal.",

  },
  {
    icon: "📅",
    title: "Juillet 2023",
    subtitle: "Stage chiens réactifs",
    description: "Approfondissement des méthodes d’accompagnement des chiens réactifs face aux humains et congénères, avec Jeremy Serindat.",
    link: "stage_chien_reactif.jpg",
  },
  {
    icon: "🐕‍🦺",
    title: "2023 - 2024",
    subtitle: "Éducatrice comportementaliste canin et félin chez Vox animæ",
    description: "Formation complète en éducation et comportementalisme canin et félin, basée sur des méthodes bienveillantes et respectueuses.",
    link: "diplome_vox_animae.jpg",
  },
  {
    icon: "📜",
    title: "2024",
    subtitle: "Permis de détention de chien de catégorie 1 et 2",
    description:
      "Formation obligatoire permettant d’acquérir les connaissances nécessaires à la détention et la gestion des chiens de catégories 1 et 2, conformément à la législation en vigueur.",
    link: "permis_de_detention.jpg",
  },
];